import type { ReactNode } from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  type TooltipVariant,
} from "@/components/ui/tooltip";

type FieldHelpTooltipProps = {
  /** Texte de la bulle. Si vide / falsy, le label est rendu tel quel. */
  content?: ReactNode;
  children: ReactNode;
  /**
   * `info` (type 2) : nature des champs — déclenché uniquement sur le label.
   * `action` (type 1) : boutons / actions — à poser aussi sur l'objet.
   */
  variant?: Extract<TooltipVariant, "action" | "info">;
  side?: "top" | "bottom" | "left" | "right";
};

/**
 * Bulle d'aide autour d'un label (ou d'un contrôle pour le type action).
 * Type 2 (`info`) : à utiliser uniquement sur le libellé du champ.
 */
export function FieldHelpTooltip({
  content,
  children,
  variant = "info",
  side = "bottom",
}: FieldHelpTooltipProps) {
  if (content == null || content === false || content === "") {
    return <>{children}</>;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex max-w-full">{children}</span>
      </TooltipTrigger>
      <TooltipContent variant={variant} side={side} className="text-sm">
        {typeof content === "string" ? <p>{content}</p> : content}
      </TooltipContent>
    </Tooltip>
  );
}
